import React from 'react';
import { Card, Tag, Space } from 'antd';
import { Link } from 'react-router-dom';
import './index.css';

const { Meta } = Card;

const PostCard = ({ post }) => {
  return (
    <div className="post-card">
      <Link to={`/post/${post.id}`}>
        <Card
          hoverable
          className="post-card-container"
          cover={
            <div className="post-card-image">
              <h3 className="post-card-title">{post.title}</h3>
            </div>
          }
        >
          <Meta 
            title={
              <Space className="post-meta" size="small">
                <span className="post-author">作者: {post.author}</span>
                <span className="post-date">{post.date}</span>
                <span className="post-read-time">{post.readTime}</span>
              </Space>
            } 
            description={post.excerpt} 
          />
          <div className="post-tags">
            {post.tags.map((tag, index) => (
              <Tag key={index} color="blue">
                {tag}
              </Tag>
            ))}
          </div>
        </Card>
      </Link>
    </div>
  );
};

export default PostCard;